import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

const Home = () => {
  return (
    <Layout>
      <Seo title="Software Engineer" />
      <div className="home">
        <div className="bio">
          <span>Hi 👋</span>
          <span>
            I'm <strong>Abolfazl Panbehkar</strong>
          </span>
          <span>a passionate Software Engineer 💻</span>
        </div>
        <div className="avatar">
          <StaticImage
            src="../assets/images/avatar.png"
            alt="abolfazl panbehkar"
          />
        </div>
      </div>
    </Layout>
  )
}

export default Home
